import React, { useEffect } from 'react';
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import './globals.css';

const Registration = () => {
  useEffect(() => {
    document.title = "IWPFI2026_Registration";
  }, []);
  return (
    <div id="everything">
      <NavigationBar />

      <main className="page-registration">
        <section className="registration-section">
          <h1 className="registration-title">
            Registration Now Open – 12th IWPFI 2026
          </h1>
          <p>
            For information about the venue and accommodation, please visit the{" "}
            <a href="/Accommodation"><u>ACCOMMODATION</u></a> section or to book your room now, click below:
          </p>
          <div className="reg-button-wrapper">
            <a 
              href="https://book.passkey.com/event/51140628/owner/56397/home?lang=en_CA" 
              target="_blank" 
              rel="noopener noreferrer"
              className="reg-button"
            >
              Book your Hotel Room
            </a>
          </div>
          {/* <div className="reg-button-wrapper">
            <a
              href="https://conference.has.uwo.ca/Register/default.aspx?code=C001948"
              target="_blank"
              rel="noopener noreferrer"
              className="reg-button"
            >
              Register Now
            </a>
          </div> */}
        </section>

        <section className="registration-card">
          <h2 className="registration-subtitle">Registration Rates</h2>

          <div className="registration-table-wrapper">
            <table className="registration-table" aria-label="Registration Rates">
              <thead>
                <tr>
                  <th>Rate Type</th>
                  <th>
                    Early Bird Rate
                    <div className="registration-col-sub">
                      until May 29, 2026
                      <br />
                      at 11:59 p.m. EDT
                    </div>
                  </th>
                  <th>
                    Regular Rate
                    <div className="registration-col-sub">
                      Between May 29 and Sept. 14, 2026
                      <br />
                      at 11:59 p.m. EDT
                    </div>
                  </th>
                  <th>
                    Late Rate
                    <div className="registration-col-sub">
                      After Sept. 14, 2026
                      <br />
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <th scope="row">Trainee</th>
                  <td>$150</td>
                  <td>$250</td>
                  <td>$350</td>
                </tr>
                <tr>
                  <th scope="row">Scientist/MD</th>
                  <td>$550</td>
                  <td>$650</td>
                  <td>$1,000</td>
                </tr>
                <tr>
                  <th scope="row">Corporate Attendee</th>
                  <td>$4,000</td>
                  <td>$4,500</td>
                  <td>$5,000</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="registration-notes">
            <p>
              All rates are posted in <strong>Canadian Dollars (CAD)</strong>.
            </p>
            <p>
              Taxes <strong>5% GST</strong> will be applied at time of check-out.
            </p>
          </div>

          <div className="reg-button-wrapper registration-cta">
            <a
              href="https://conference.has.uwo.ca/Register/default.aspx?code=C001948"
              target="_blank"
              rel="noopener noreferrer"
              className="reg-button"
            >
              Register Now
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Registration;

